/* eslint-disable */

import API from '@/api';
import { SET_RECORDING, SET_LOADING } from './mutation-types';

/**
 * State
 */
const state = {
  isRecording: false,
  isLoading: false
};

/**
 * Getters
 */
const getters = {
  isRecording: state => state.isRecording,
  isLoading: state => state.isLoading
};

/**
 * Actions
 */
const actions = {
  setRecording({ commit, state }, status) {
    commit(SET_RECORDING, status);
  },
  setLoading({ commit, state }, status) {
    commit(SET_LOADING, status);
  }
};

/**
 * Mutations
 */
const mutations = {
  [SET_RECORDING](state, status) {
    state.isRecording = status;
  },
  [SET_LOADING](state, status) {
    state.isLoading = status;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
